import { FC } from "react";

import { WhiteLabelHomeLayout } from "@/layout/WhiteLabel";
import { GetAdvantageCard, HomeFAQs, HomeHero, WaysToSave } from "@/components/WhiteLabelComponents";

export const WhiteLabelHome: FC = () => {
  return (
    <WhiteLabelHomeLayout>
      <HomeHero />
      <GetAdvantageCard />
      <WaysToSave />
      <HomeFAQs />
    </WhiteLabelHomeLayout>
  );
};
